import { LoadingSpinner } from 'core/components/common/LoadingSpinner';
import { Header } from 'core/components/header';
import { useCurrentUserEmsTeam } from 'core/components/header/hooks/useCurrentUserEmsTeam';
import { getSectionByDepartmentId } from 'sections/sectionConfig';
import { SectionRoutes } from 'sections/SectionRouter';

export const PrivateRouteLayout = () => {
  const { emsTeam, isLoading } = useCurrentUserEmsTeam();
  const sectionType = getSectionByDepartmentId(emsTeam?.departmentId);

  if (isLoading) return <LoadingSpinner />;

  return (
    <div>
      <Header />
      <main>
        <div className="bg-background py-[40px] min-h-screen">
          <SectionRoutes sectionType={sectionType} />
        </div>
      </main>
    </div>
  );
};
